module.exports = __webpack_public_path__ + "img/inc.3b43e896.svg";